import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Image,
  FlatList,
  Dimensions,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppColors } from "../../../utility/AppColors";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { CommonButton } from "../../../common/CommonButton";
import { AppScreens } from "../../Utility/AppScreens";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import { AppImages } from "../../../utility/AppImages";
import { ScrollView } from "react-native-gesture-handler";
import { MobileDeviceNavigationHeader } from "./Common/MobileDeviceNavigationHeader";
import { toast } from "react-toastify";
import { base_url, endpoints } from "../../../Api/configs";
import { getLoginData } from "../../../utility/AppStoreData";
import { ShowLoader } from "../../../common/ShowLoader";
import { screenWidth } from "../../../utility/Index";
import { disputesGetAll, disputesSend } from "../../../services/disputesAPI";
import { handleApiError } from "../../../services/errorHandler";
import { uploadToS3 } from "../../../services/authAPI";
import * as ImagePicker from "expo-image-picker";
import NoDataFound from "../../../Components/NoDataFound";
import Header from "./Common/Header";
import DisputeDetailsPopup from "../../../Components/dispute-center-common-components/DisputeDetailsPopup";
import { ScreenBGGradientView } from "../../../common/CommonView";
import Skeletons from "../../../Components/skeleton-components/Skeletons";

export default function DisputeCenter() {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const [showLoader, setShowLoader] = useState(false);
  const [userData, setUserData] = useState(null);
  const [arrDisputeList, setArrDisputeList] = useState([]);
  const [picture, setPicture] = useState<string | null>(null);
  const [uploadingDisputeID, setUploadingDisputeID] = useState<string | null>(
    null
  );
  const [selectedDisputeID, setSelectedDisputeID] = useState<string | null>(
    null
  );
  const [selectedDispute, setSelectedDispute] = useState<string | null>(null);
  const [proofUrl, setProofUrl] = useState<string | null>(null);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [disputeDetailsPopup, setDisputeDetailsPopup] = useState(false);
  const accessTokenRef = useRef<string | null>(null);
  const isSmallOrXS =
    deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;
  let skeletonCards = Array(10).fill(0);

  useEffect(() => {
    getLoginUserData((loginData: any) => {
      console.log("Login Data successfully fetched", loginData);
    });
  }, []);

  async function getLoginUserData(successResponse: Function) {
    const data = await getLoginData();

    if (data) {
      setUserData(data);
      accessTokenRef.current = data.AccessToken;
      successResponse(data);

      if (accessTokenRef.current) {
        disputesGetAllAPI((response) => {
          setArrDisputeList(response.disputes);
        });
      }
    }
  }

  const disputesGetAllAPI = async (successResponse: Function) => {
    setShowLoader(true);
    try {
      const accessToken = accessTokenRef.current;
      if (!accessToken) {
        throw new Error("Access token not set.");
      }

      const data = await disputesGetAll(accessToken);
      const responseData = await data.body;
      setShowLoader(false);

      if (data.statusCode === 200) {
        successResponse(responseData);
      } else {
        toast.error(responseData.error);
      }
    } catch (error) {
      setShowLoader(false);
      console.error("Authorization failed:", error.message);
      toast.error(error.message);
    }
  };

  const pickImage = async (disputeID: string, disputeTimestamp: string) => {
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      aspect: [4, 3],
      quality: 1,
    });

    if (!result.canceled) {
      setPicture(result.assets[0].uri);
      setUploadingDisputeID(disputeID);
      const fileContent = result.assets[0].uri;
      await callUploadToS3API(
        `dispute-${disputeID}`,
        fileContent,
        disputeID,
        disputeTimestamp
      );
    }
  };

  const callUploadToS3API = async (
    fileName: string,
    fileContent: string,
    disputeID: string,
    disputeTimestamp: string
  ) => {
    const bodyParams = {
      bucketName: "squdifi-event-thumbnail",
      fileName: fileName,
      fileContent: fileContent,
      disputeID: disputeID,
    };

    try {
      setShowLoader(true);
      const response = await uploadToS3(bodyParams);

      if (response.statusCode === 200 || response.statusCode === 201) {
        const fileUrl = response.body.fileUrl;
        toast.success("File uploaded successfully!");
        setProofUrl(fileUrl);
        setSelectedDisputeID(disputeID);
        setSelectedDispute(disputeTimestamp);
        setIsSubmitDisabled(false);
        updateDisputeProof(disputeID, fileUrl);
      } else {
        toast.error(response.body?.error || "File upload failed!");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setShowLoader(false);
    }
  };

  const updateDisputeProof = (disputeID: string, fileUrl: string) => {
    setArrDisputeList((prevDisputes) =>
      prevDisputes.map((dispute) =>
        dispute.DisputeID === disputeID
          ? { ...dispute, ProofUrl: fileUrl }
          : dispute
      )
    );
  };

  const submitDisputeProof = async () => {
    if (!selectedDisputeID || !proofUrl) return;

    try {
      setShowLoader(true);
      const accessToken = accessTokenRef.current;
      if (!accessToken) {
        throw new Error("Access token not set.");
      }

      const response = await disputesSend(
        accessToken,
        selectedDisputeID,
        proofUrl,
        selectedDispute
      );

      if (response.statusCode === 200 || response.statusCode === 201) {
        toast.success("Dispute proof submitted successfully!");
        updateDisputeAction(selectedDisputeID);
        setIsSubmitDisabled(true);
      } else {
        toast.error(response.body?.error || "Failed to submit dispute!");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setShowLoader(false);
    }
  };

  const updateDisputeAction = (disputeID: string) => {
    setArrDisputeList((prevDisputes) =>
      prevDisputes.map((dispute) =>
        dispute.DisputeID === disputeID
          ? {
              ...dispute,
              ActionUser1:
                dispute.User1 === userData?.username
                  ? "Submitted"
                  : dispute.ActionUser1,
              ActionUser2:
                dispute.User2 === userData?.username
                  ? "Submitted"
                  : dispute.ActionUser2,
            }
          : dispute
      )
    );
  };

  const renderDisputeCenterItem = ({ item }: any) => {
    const isUser1 = item.User1 === userData?.username;
    const actionStatus = isUser1 ? item.ActionUser1 : item.ActionUser2;
    const proofLocation = isUser1
      ? item.ProofLocationUser1
      : item.ProofLocationUser2;

    return (
      <View
        key={item.DisputeID}
        style={{
          height: 32,
          flexDirection: "row",
          paddingTop: 10,
          gap: 10,
          marginTop: 10,
          flex: 1,
        }}
      >
        <View style={styles.itemWidth}>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_14,
              {
                paddingTop: 12,
                lineHeight: 20,
                height:
                  deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 50 : 70,
              },
            ]}
            numberOfLines={2}
            ellipsizeMode="tail"
          >
            {item.EventName}
          </Text>
          <View
            style={{
              height: 1,
              marginTop: 10,
              backgroundColor: AppColors.grayColor_505050,
            }}
          />
        </View>

        <View style={styles.itemWidth}>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_14,
              {
                paddingVertical: 12,
                height:
                  deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 60 : 80,
              },
            ]}
          >
            {item.EventID}
          </Text>
          <View
            style={{ height: 1, backgroundColor: AppColors.grayColor_505050 }}
          />
        </View>

        <View style={styles.itemWidth}>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_14,
              {
                paddingVertical: 12,
                height:
                  deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 60 : 80,
              },
            ]}
          >
            {item.Reason}
          </Text>
          <View
            style={{ height: 1, backgroundColor: AppColors.grayColor_505050 }}
          />
        </View>

        <View style={styles.itemWidth}>
          <View style={{ flexDirection: "row", columnGap: 8 }}>
            {proofLocation ? (
              <Image
                source={{ uri: proofLocation }}
                style={{
                  height: 50,
                  width: 50,
                  resizeMode: "contain",
                }}
              />
            ) : (
              <TouchableOpacity
                onPress={() => pickImage(item.DisputeID, item.Timestamp)}
              >
                {uploadingDisputeID === item.DisputeID && picture ? (
                  <Image
                    source={{ uri: picture }}
                    style={{
                      height: 50,
                      width: 50,
                      resizeMode: "contain",
                    }}
                  />
                ) : (
                  <Image
                    source={AppImages.icUpload}
                    style={{
                      height: 20,
                      width: 16,
                      resizeMode: "contain",
                      paddingVertical: 15,
                    }}
                  />
                )}
              </TouchableOpacity>
            )}
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                {
                  paddingVertical: 12,
                  height:
                    deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 60 : 80,
                },
              ]}
            >
              Screen short
            </Text>
          </View>
          <View
            style={{ height: 1, backgroundColor: AppColors.grayColor_505050 }}
          />
        </View>

        <View
          style={[
            {
              paddingTop: 12,
              height: deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 61 : 81,
              justifyContent: "space-between",
            },
            styles.itemWidth,
          ]}
        >
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_14,
              {
                color: actionStatus === "Submitted" ? "green" : "white",
                paddingVertical: 5,
                paddingHorizontal: 10,
                marginBottom: 8,
                backgroundColor:
                  actionStatus === "Submitted"
                    ? AppColors.green_4CD964
                    : AppColors.grayColor_565656,
                borderRadius: 8,
                alignSelf: "center",
              },
            ]}
          >
            {actionStatus}
          </Text>
          <View
            style={{ height: 1, backgroundColor: AppColors.grayColor_505050 }}
          />
        </View>

        <View
          style={[
            {
              paddingTop: 12,
              height: deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 61 : 81,
              justifyContent: "space-between",
            },
            styles.itemWidth,
          ]}
        >
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_14,
              {
                color: "white",
                paddingVertical: 5,
                paddingHorizontal: 10,
                marginBottom: 8,
                backgroundColor: AppColors.grayColor_565656,
                borderRadius: 8,
                alignSelf: "center",
              },
            ]}
          >
            {item.UserRewarded}
          </Text>
          <View
            style={{ height: 1, backgroundColor: AppColors.grayColor_505050 }}
          />
        </View>
      </View>
    );
  };

  return (
    <View
      style={{
        flex: 1,
      }}
    >
      <ScreenBGGradientView />
      {/* {deviceSize === DEVICE_SIZES.XS ? (
        <MobileDeviceNavigationHeader
          btnNotificationTapped={() => {}}
          btnSettingTapped={() => {
            navigateToScreen(navigation, AppScreens.SettingWebScreen);
          }}
          btnSearchTapped={() => {
            navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
          }}
        />
      ) : null} */}
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {}}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
      />

      <View style={styles.container}>
        <View style={[{ columnGap: 10 }]}>
          <Text
            style={[AppFontStyle.BOLD_ANYBODY_32, { color: AppColors.white }]}
          >
            Dispute Center
          </Text>
          <View
            style={{
              height: 2,
              backgroundColor: AppColors.grayColor_505050,
              marginTop: 15,
            }}
          />
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_14,
              { color: AppColors.white, marginTop: 20 },
            ]}
          >
            Ongoing disputes
          </Text>
        </View>

        <ScrollView
          horizontal={true}
          contentContainerStyle={{
            flexDirection: "row",
            flexGrow: 1,
          }}
          showsHorizontalScrollIndicator={false}
        >
          <View style={{ flexDirection: "row", minWidth: "100%" }}>
            <View style={[styles.TicketBeltView]}>
              <View style={[styles.centerDivider, { marginVertical: 10 }]} />

              {showLoader ? (
                <Skeletons height={40} width={"100%"} />
              ) : (
                <View
                  style={{
                    flexDirection: "row",
                    backgroundColor: AppColors.grayColor_565656,
                    paddingHorizontal: 15,
                    height: 40,
                    gap: 10,
                  }}
                >
                  {[
                    "Event Name",
                    "Event ID",
                    "Reason",
                    "Upload proof",
                    "Action",
                    "User Rewarded",
                  ].map((item, index) => (
                    <View
                      key={index}
                      style={[
                        {
                          padding: 4,
                          justifyContent: "flex-start",
                          flexDirection: "row",
                          gap: 8,
                          alignItems: "center",
                          paddingVertical: 10,
                          backgroundColor: AppColors.grayColor_565656,
                        },
                        styles.itemWidth,
                      ]}
                    >
                      <Text
                        style={[
                          deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                            ? AppFontStyle.REGULAR_ANYBODY_14
                            : AppFontStyle.REGULAR_ANYBODY_12,
                          { color: AppColors.white },
                        ]}
                      >
                        {item}
                      </Text>
                    </View>
                  ))}
                </View>
              )}

              {showLoader ? (
                skeletonCards.map((_, index) => (
                  <Skeletons
                    key={index}
                    height={40}
                    width={"100%"}
                    style={{ marginTop: 10 }}
                  />
                ))
              ) : arrDisputeList.length === 0 ? (
                <View
                  style={{
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: 300,
                    marginRight: 0,
                  }}
                >
                  <NoDataFound text={"NO DISPUTE UNTIL NOW"} />
                </View>
              ) : (
                <FlatList
                  style={{ minWidth: "100%" }}
                  data={arrDisputeList}
                  renderItem={({ item, index }) =>
                    renderDisputeCenterItem({ item, index })
                  }
                  keyExtractor={(item) => item.id}
                  nestedScrollEnabled={true}
                />
              )}
            </View>
          </View>
        </ScrollView>

        <View
          style={{
            flexDirection: "row",
            columnGap: 10,
            margin: 20,
            alignSelf: "flex-end",
          }}
        >
          <TouchableOpacity
            style={[styles.backButtonStyle, { backgroundColor: "transparent" }]}
            onPress={() => {
              navigation.dispatch(StackActions.pop());
            }}
          >
            <Text style={[AppFontStyle.BOLD_ANYBODY_12, { color: "white" }]}>
              Back
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={[
              styles.submitButtonStyle,
              {
                backgroundColor: isSubmitDisabled
                  ? AppColors.grayColor_505050
                  : AppColors.appViolentColor_6D08C3,
              },
            ]}
            onPress={submitDisputeProof}
            disabled={isSubmitDisabled}
          >
            <Text style={[AppFontStyle.BOLD_ANYBODY_12, { color: "white" }]}>
              Submit
            </Text>
          </TouchableOpacity>
        </View>
      </View>
      {<ShowLoader showIndicater={showLoader} />}
      {disputeDetailsPopup && (
        <DisputeDetailsPopup
          disputeDetailsPopup={disputeDetailsPopup}
          setDisputeDetailsPopup={setDisputeDetailsPopup}
        />
      )}
    </View>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      paddingHorizontal: "3%",
      paddingTop: "2.5%",
    },
    backButtonStyle: {
      height: 40,
      paddingHorizontal: 45,
      paddingVertical: 12,
      borderRadius: 10,
      borderColor: AppColors.appViolentColor_6D08C3,
      borderWidth: 1,
    },
    submitButtonStyle: {
      height: 40,
      paddingHorizontal: 45,
      paddingVertical: 12,
      borderRadius: 10,
      borderColor: AppColors.appViolentColor_6D08C3,
      borderWidth: 1,
    },
    // itemWidth: {
    //   minWidth: "16%",
    //   maxWidth: screenWidth / 8,
    // },
    TicketBeltView: {
      minWidth: "100%", // ✅ Ensures table expands beyond screen
      borderRadius: 10,
      paddingBottom: 15,
      gap: 10,
    },
    centerDivider: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      height: 2,
    },
    itemWidth: {
      minWidth: "16%",
      maxWidth: screenWidth / 8,
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      itemWidth: {
        width: 250,
      },
    },
    [DEVICE_SIZES.LG]: {
      itemWidth: {
        width: 220,
      },
    },
    [DEVICE_SIZES.SM]: {
      itemWidth: { minWidth: "16%", width: 130 },
      TicketBeltView: { minWidth: "300%" },
    },
    [DEVICE_SIZES.XS]: {
      itemWidth: { minWidth: "16%", width: 130 },
      TicketBeltView: { minWidth: "300%" },
    },
  }
);
